import type { ComponentProps } from "react";
import { PhysiologyFields } from "./PhysiologyFields";

/**
 * “Tune your fueling plan” inset — branded lime chrome, shared by the
 * onboarding / manual-session modals and Preferences.
 * Inner sex/weight layout: `PhysiologyFields` `variant="tune-split"`.
 */
export type TunePhysiologyCardProps = Omit<ComponentProps<typeof PhysiologyFields>, "variant">;

export function TunePhysiologyCard(props: TunePhysiologyCardProps) {
  return (
    <div className="fg-tunePhys">
      <div className="fg-tunePhys__title">
        Tune your fueling plan<span className="fg-tunePhys__optional">optional</span>
      </div>
      <p className="fg-tunePhys__body">
        This helps us match your fuel to your needs. (You can always add it later too).
      </p>
      <PhysiologyFields {...props} variant="tune-split" />
    </div>
  );
}
